import React, { useState } from "react";

import { useGetAntennaQuery } from "gql/generated/types";
import { Button } from "primereact/button";
import { useNavigate, useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { DweenColors } from "utils/enums";
import AntennaFormDialog from "./AntennaFormDialog";

const AntennaInfo: React.FC = () => {
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const { antennaId } = useParams();
  const { data } = useGetAntennaQuery({ variables: { id: antennaId! }, skip: !antennaId });

  return (
    <div className="flex flex-column gap-6 my-3">
      <div className="info-table-wrapper">
        <table className="info-table">
          <caption>{T("mdm.antenna")}</caption>
          <tbody>
            <tr>
              <th>{T("word.title")}:</th>
              <td>{data?.mdmAntennaById.title ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.description")}:</th>
              <td>{data?.mdmAntennaById.description ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.city")}:</th>
              <td>{data?.mdmAntennaById.city ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.street")}:</th>
              <td>{data?.mdmAntennaById.street ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.house-number")}:</th>
              <td>{data?.mdmAntennaById.houseNumber ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.latitude")}:</th>
              <td>{data?.mdmAntennaById.latitude ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.longitude")}:</th>
              <td>{data?.mdmAntennaById.longitude ?? "-"}</td>
            </tr>
            <tr>
              <th>{T("word.radius")}:</th>
              <td>{data?.mdmAntennaById.radius ?? "-"}m</td>
            </tr>
            <tr>
              <th>{T("word.color")}:</th>
              <td>
                {data?.mdmAntennaById.color ?? "-"}
                <div
                  style={{
                    backgroundColor: data?.mdmAntennaById.color ?? DweenColors.Blue400,
                    height: "1.2rem",
                  }}
                  className="w-3rem inline-block border-round-md ml-2 vertical-align-middle"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex gap-3 align-self-end">
        <Button
          onClick={() => setEditMode(true)}
          type="button"
          label={T("action.edit")}
          className="w-10rem"
          size="small"
          rounded
        />
        <Button
          type="button"
          onClick={() => navigate(-1)}
          label={T("action.back")}
          className="w-10rem"
          severity="secondary"
          size="small"
          outlined
          rounded
        />
      </div>
      <AntennaFormDialog antenna={data?.mdmAntennaById} showDialog={editMode} setShowDialog={setEditMode} />
    </div>
  );
};

export default AntennaInfo;
